import script from "./RequestSampleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestSampleForm.vue?vue&type=script&setup=true&lang=js"

import "./RequestSampleForm.vue?vue&type=style&index=0&id=25f6df89&lang=less"

const __exports__ = script;

export default __exports__